module.exports = __webpack_public_path__ + "img/lg_ring_r_l_0_null@3x.158c837c.png";